module.exports = __webpack_public_path__ + "img/yt-pa_pendle.4c1bc300.png";